module.exports = __webpack_public_path__ + "img/ps.15cf1351.svg";